"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b ||= {})
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
import React from "react";
import classNames from "classnames";
import { IconSize } from "../types";
import * as styles from "../Icons-css";
const Strikethrough = (props) => {
  const _a = props, { className, size = IconSize.Medium, color = "inherit" } = _a, rest = __objRest(_a, ["className", "size", "color"]);
  const iconClass = classNames(
    styles.icon({
      size,
      color
    }),
    "kl-icon",
    `kl-icon--${size}`,
    className
  );
  return React.createElement(
    "svg",
    __spreadValues({ width: "24", height: "24", viewBox: "0 0 24 24", className: iconClass }, rest),
    /* @__PURE__ */ React.createElement(
      "path",
      {
        fillRule: "evenodd",
        d: "M6.391 14.975h3.036c.391 1.242 1.426 1.817 2.806 1.817 1.426 0 2.369-.644 2.369-1.771 0-.432-.13-.764-.418-1.021h3.237c.052.263.079.542.079.837 0 2.737-2.254 4.393-5.244 4.393-3.151 0-5.382-1.564-5.865-4.255ZM10.967 13H2v-1h6.253c-.912-.634-1.494-1.588-1.494-3.005 0-2.553 2.116-4.347 5.083-4.347 3.22 0 5.083 1.702 5.543 4.094h-2.921c-.322-.943-1.127-1.68-2.599-1.68-1.334 0-2.231.645-2.231 1.657 0 .805.529 1.288 1.587 1.54l2.576.599c1.003.23 1.835.61 2.455 1.142H22v1H10.967Z"
      }
    )
  );
};
export default Strikethrough;
